import React, { memo } from 'react'
import { string, bool } from 'prop-types'

import classNames from 'src/common/helpers/class-names'

const WasPrice = memo(({
  className, wasPrice, showUom, pricePerUOM, blk, showTextWas,
}) => {
  if (!wasPrice) return null
  const renderUom = (price) => {
    const indexOfUom = price.indexOf('/')
    return price.slice(indexOfUom)
  }
  return (
    <span
      aria-label={`Was ${wasPrice}`}
      className={classNames({ className, blk, elt: 'was-price' })}
    >
      {showTextWas && 'was '}
      { showUom ? `${wasPrice} ${renderUom(pricePerUOM)}` : wasPrice }
    </span>
  )
})

WasPrice.propTypes = {
  className: string,
  wasPrice: string,
  showUom: bool,
  showTextWas: bool,
  pricePerUOM: string,
  blk: string,
}

WasPrice.defaultProps = {
  className: '',
  wasPrice: '',
  pricePerUOM: '',
  showUom: false,
  showTextWas: false,
  blk: 'co-product',
}

export default WasPrice



// WEBPACK FOOTER //
// ./shared/interim/product/was-price/index.js